import axios from "axios";

const moduleProductInventory = {
  namespaced: true,
  state: {
    productList: [],
    allGRWithProductList: [],
    createProductItem: null,
    productListLastUpdated: null,
  },
  mutations: {
    setProductList(state, data) {
      state.productList = data;
    },
    setAllGRWithProductList(state, data) {
      state.allGRWithProductList = data;
    },
    setProductListLastUpdated(state, data) {
      state.productListLastUpdated = data;
    },
  },
  actions: {
    async fetchProductList({ commit }, { clinicUrl, branchUrl }) {
      try {
        const res = await axios.get(`/api/stocks/${clinicUrl}/${branchUrl}`);
        const items = res.data.data.map(i => ({
          productId: i.product.id,
          productCode: i.product.no,
          productCategory: i.product.category,
          productNameMain: i.product.description,
          productNameAdditional: i.product.description2,
          productStock: i.qtyAvailable,
          productUnit: i.product.baseUom,
          productPrice: i.avgCost,
          productStatus: i.product.status,
          productPurchaseUnit: i.product.purchaseUom,
          productSalesUnit: i.product.saleUom,
          productConversionUnitItems: i.product.productUomConversions,
          productAvailableStock: i.qtyAvailable,
        }));

        const lastUpdated = res.data.lastCutoffStock;

        commit("setProductListLastUpdated", lastUpdated);

        commit("setProductList", items);
        return items;
      } catch (err) {
        console.error("fetchProductList failed", err);
        throw err;
      }
    },
    createProductItem({ commit, getters }, payload) {
      return axios
        .post(
          `/api/master/products/${payload.clinicUrl}/${payload.branchUrl}`,
          payload.adjustProductItem,
          {
            skipGlobalErrorHandler: true,
          }
        )
        .then(res => {
          return res;
        })
        .catch(err => {
          throw err;
        });
    },
    updateProductItem({ commit, getters }, payload) {
      return axios
        .put(
          `/api/master/products/${payload.clinicUrl}/${payload.branchUrl}/${payload.id}`,
          payload.adjustProductItem,
          {
            skipGlobalErrorHandler: true,
          }
        )
        .then(res => {
          return res;
        })
        .catch(err => {
          throw err;
        });
    },
    deleteProductItem({ commit, getters }, payload) {
      return axios
        .delete(
          `/api/master/products/${payload.clinicUrl}/${payload.branchUrl}/${payload.id}`,
          {
            skipGlobalErrorHandler: true,
          }
        )
        .then(res => {
          return res;
        })
        .catch(err => {
          throw err;
        });
    },
    getProductHistoryById({ commit, getters }, payload) {
      return axios
        .get(
          `/api/stockLedgers/${payload.clinicUrl}/${payload.branchUrl}/${payload.id}`
        )
        .then(res => {
          return res;
        })
        .catch(err => {
          // Automatic error handling via interceptor
          throw err;
        });
    },
    createStockAdjustment({ commit, getters }, payload) {
      return axios
        .post(
          `/api/stockAdjustment/${payload.clinicUrl}/${payload.branchUrl}`,
          payload.adjustStockData,
          {
            skipGlobalErrorHandler: true,
          }
        )
        .then(res => {
          return res;
        })
        .catch(err => {
          throw err;
        });
    },
    async fetchAllGRWithProductList({ commit }, { clinicUrl, branchUrl }) {
      try {
        const res = await axios.get(
          `/api/goodreceive/${clinicUrl}/${branchUrl}/dropdown`
        );
        const items = res.data.data.map(i => ({
          grNo: i.refDocNo,
          grProduct: i.goodReceiveProducts.map(item => ({
            product: {
              productId: item.product.id,
              productCode: item.product.no,
              productNameMain: item.product.description,
            },
            unit: {
              unitId: item.uom.id,
              unitNameTh: item.uom.description,
            },
            stockAvailable: item.qtyAvailable,
            stockOnGR: item.qtyUom,
          })),
        }));

        commit("setAllGRWithProductList", items);
        return items;
      } catch (err) {
        console.error("fetchAllGRWithProductList failed", err);
        throw err;
      }
    },
  },
  getters: {
    getProductList: state => {
      return state.productList;
    },
    getAllGRWithProductList: state => {
      return state.allGRWithProductList;
    },
    getProductListLastUpdated: state => {
      return state.productListLastUpdated;
    },
  },
};

export default moduleProductInventory;
